import Vue from 'vue'
import moment from 'moment'


Vue.prototype.$moment = moment
// 中文简体
moment.locale('zh-cn')
export function moment_format(value, fmt){
	return value?moment(value).format(fmt):'';
}
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null;
    }

    if ((time + "").length === 10) {
        time = +time * 1000;
    }

    const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
    let date;
    if (typeof time === "object") {
        date = time;
    } else {
        date = new Date(parseInt(time));
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    };
	const l = localStorage.getItem('locale')
	var weeks = null;
	if(l && !(l=="zh_CN" || l=="zh_TW")){
		weeks = ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"];
	}else{
		weeks = ["一", "二", "三", "四", "五", "六", "日"];
	}
    const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === "a")
            return weeks[value - 1];
        if (result.length > 0 && value < 10) {
            value = "0" + value;
        }
        return value || 0;
    });
    return timeStr;
}
export function formatTime(time, option) {
    time = +time * 1000;

    const d = new Date(time);
    const now = Date.now();

    const diff = (now - d) / 1000;


	const l = localStorage.getItem('locale')

	var arr = null;
	if(l && !(l=="zh_CN" || l=="zh_TW")){
		arr = l=="zh_TW"?["剛剛", "分鐘前", "小時前", "1天前", "月", "日", "時","分"]:["刚刚", "分钟前", "小时前", "1天前", "月", "日", "时","分"];
	}else{
		arr = ["刚刚", "分钟前", "小时前", "1天前", "月", "日", "时","分"];//["Just", "Mins", "Hours", "1day", "M", "d", "H","m"];
	}
    if (diff < 30) {
        return arr[0];
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + arr[1];
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + arr[2];
    } else if (diff < 3600 * 24 * 2) {
        return arr[3];
    }
    if (option) {
        return parseTime(time, option);
    } else {
        return (
            (d.getMonth() + 1) +
            arr[4] +
            d.getDate() +
            arr[5] +
            d.getHours() +
            arr[6] +
            d.getMinutes() +
            arr[7]
        );
    }
}

export function converMoney(value) {
    value = Math.abs(value)
	const l = localStorage.getItem('locale')
	if(l && !(l=="zh_CN" || l=="zh_TW")){
		if (parseFloat(value) > 1000) {
			return number_format(parseFloat(value) / 1000,2) + 'K'
		}
	}else{
		if (parseFloat(value) > 10000) {
			return number_format(parseFloat(value) / 10000,2) + (l=="zh_TW"?'萬':'万')
		}
	}
    return number_format(value,2)
}

export function number_format(number, decimals, dec_point, thousands_sep, roundtag) {
    /*
     * 参数说明：
     * number：要格式化的数字
     * decimals：保留几位小数
     * dec_point：小数点符号
     * thousands_sep：千分位符号
     * roundtag:舍入参数，默认 "ceil" 向上取,"floor"向下取,"round" 四舍五入
     * */
    number = (number + '').replace(/[^0-9+-Ee.]/g, '');
    roundtag = roundtag || "round";
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + parseFloat(Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(prec * 2)) / k;
        };
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    var re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
    }

    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

export function distance_format(dis){
	if(dis){
		if(dis > 999){
			return number_format(dis/1000) + 'km';
		}
		return dis + 'm';
	}else{
		return '0m';
	}
}


// WEBPACK FOOTER //
// ./src/filters/index.js